import MatterStatusesSettingsView from "@/components/features/settings/defaults/matter-statuses/MatterStatusesSettingsView";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { REFERRAL_STATUS_CATEGORY_OPTIONS } from "@/lib/data/static/matterStatics";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/referrals/settings/statuses")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.referralsSettingsStatuses)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <div className="flex flex-col gap-6">
      <MatterStatusesSettingsView
        title="Statuses"
        addButtonLabel="Add status"
        categoryOptions={REFERRAL_STATUS_CATEGORY_OPTIONS}
      />
    </div>
  );
}
